import moment from "moment";

export function GenerarEstaSemana(dias) {
  const semana = [];

  // dias puede ser: -7, 0 o 7 dependiendo si es semana anterior, actual o siguiente
  const inicioDeSemana = moment().add(dias, "days").startOf("isoWeek");

  for (let i = 0; i < 5; i++) {
    semana.push({
      fecha: inicioDeSemana.clone().add(i, "days").format("YYYY-MM-DD"),
    });
  }

  return semana;
}
